import { RegisterFormErrors, RegisterPayload } from "src/library/types/types";

export const errorsInPayload = (errors: RegisterFormErrors, payload: RegisterPayload) => {
  if (stringIsEmpty(payload.name))
    errors = { ...errors, name: "Please enter your full name" };
  if (emailHasErrors(payload.email))
    errors = { ...errors, email: emailHasErrors(payload.email) };
  if (stringIsEmpty(payload.organisation))
    errors = { ...errors, organisation: "Please enter an educational institution" };
  // if (phoneHasErrors(payload.phone))
  //   errors = { ...errors, phone: phoneHasErrors(payload.phone) };
  // if (locationHasErrors(payload.location))
  //   errors = { ...errors, location: locationHasErrors(payload.location) };
  if (entryTypeHasErrors(payload.entryType))
    errors = { ...errors, entryType: entryTypeHasErrors(payload.entryType) };
  return errors;
};

const emailHasErrors = (emailAddress: string) => {
  if (stringIsEmpty(emailAddress)) return "Please submit an email address";
  if (!emailAddress.includes("@")) return "Email must contain an '@'";
  if (!emailAddress.includes(".")) return "Email must contain a '.'";
  return "";
};

// const phoneHasErrors = (contactNumber: string) => {
//   if (stringIsEmpty(contactNumber)) return "Please submit a mobile phone number";
//   if (isNaN(Number(contactNumber))) return "Please ensure mobile number is only numbers";
//   if (contactNumber.length < 10) return "Please ensure mobile number is 10 numbers";
//   return "";
// };

// const locationHasErrors = (location: number) => {
//   if (location === undefined || location < 1 || location > 4)
//     return "Please choose a location to attend";
//   return "";
// };

const entryTypeHasErrors = (entryType: number) => {
  if (entryType === undefined || entryType < 1 || entryType > 2)
    return "Please choose either a team or individual";
  return "";
};

const stringIsEmpty = (str: string) => {
  return str.length < 1;
};
